import React from 'react';
import { render } from 'react-dom';
import PreviewLink from './PreviewLink.jsx';

import './style.sass';

function deserialize(plugin) {
  const fieldValue = plugin.getFieldValue(plugin.fieldPath);
  if (!fieldValue) {
    if (plugin.parameters.instance.previewLinkURL) {
      return {
        previewLinkURL: plugin.parameters.instance.previewLinkURL,
        liveLinkURL: plugin.parameters.instance.liveLinkURL,
        itemId: plugin.itemId,
      };
    }

    return { };
  }

  return JSON.parse(fieldValue);
}

window.DatoCmsPlugin.init().then((plugin) => {
  plugin.startAutoResizer();

  class App extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        previewLinkState: deserialize(plugin),
      };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
      const { previewLinkState } = this.state;

      return (
        <div className="preview-link">
          <PreviewLink previewLinkState={previewLinkState} />
        </div>
      );
    }
  }

  render(<App />, document.body);
});
